import { z } from 'zod';

export const RegulatoryArtifactKind = z.enum([
  'fsma-204-cold-chain',
  'customs-filing',
  'audit-trail',
  'gdpr-data-export',
  'sovereign-il5-trail',
  'sovereign-il6-trail',
]);

export const RegulatoryArtifact = z.object({
  id: z.string(),
  tenantId: z.string(),
  kind: RegulatoryArtifactKind,
  version: z.string(),
  parentEntryIds: z.array(z.string()),
  body: z.unknown(),
  hashChain: z.string(),
  generatedAt: z.string(),
  generatedBy: z.string(),
  confidence: z.number().min(0).max(1).nullable(),
  reviewState: z.enum(['draft', 'operator-review', 'published', 'archived']),
  reviewerId: z.string().nullable(),
  reviewedAt: z.string().nullable(),
  publishedAt: z.string().nullable(),
  correlationId: z.string(),
});
